export default __webpack_public_path__ + "static/media/prognos_logotyp_rgb.d73ba15b.png";